module.exports = __webpack_public_path__ + "img/랜딩페이지_모바일_2x.2fdc4b08.jpg";